import { Controller } from "@hotwired/stimulus"
import { CLIENT_CONTRACT } from "../lib/client_contract"

export function recaptchaScriptUrl(siteKey) {
  return `${CLIENT_CONTRACT.externalLinks.recaptchaJavascriptUrl}?render=${encodeURIComponent(siteKey)}`
}

// reCAPTCHA v3 for the contact form. The Google script is loaded lazily — only
// once the user actually engages with the form (focusin) — so it isn't pulled
// in on every page. On submit we fetch a fresh token, drop it into a hidden
// field, and let the form post normally.
export default class extends Controller {
  static values = { siteKey: String }
  static targets = ["token"]

  // Inject the script once and resolve when grecaptcha is ready.
  load() {
    if (this.scriptPromise) return this.scriptPromise
    this.scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = recaptchaScriptUrl(this.siteKeyValue)
      script.async = true
      script.onload = () => grecaptcha.ready(resolve)
      script.onerror = () => reject(new Error("Failed to load reCAPTCHA"))
      document.head.appendChild(script)
    })
    return this.scriptPromise
  }

  async submit(event) {
    // Once we've stamped a token, the re-dispatched submit proceeds untouched.
    if (this.tokenTarget.value) return
    event.preventDefault()
    try {
      await this.load()
      this.tokenTarget.value = await grecaptcha.execute(this.siteKeyValue, { action: "contact" })
    } catch (e) {
      // If reCAPTCHA can't load, submit anyway — the server treats a missing
      // token as unverified and decides what to do.
      console.error(e)
    }
    this.element.requestSubmit()
  }
}
